/**
 * MUI theme — BOLT-022: First UI bolt.
 *
 * Minimal createTheme() that aligns MUI defaults with the 97 Display brand
 * tokens declared in index.css. Does NOT over-customize — uses MUI's
 * Material Design 3 defaults for spacing, shape, breakpoints, and transitions.
 *
 * Engineers: prefer MUI's sx prop and theme tokens over inline CSS or Tailwind.
 */
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    background: {
      default: '#f9fafb', // gray-50 — matches prototype page background
    },
    primary: {
      main: '#0284c7', // sky-600 — prototype primary
      light: '#0ea5e9', // sky-500
      dark: '#0369a1', // sky-700
    },
    error: {
      main: '#ef4444', // danger
    },
    success: {
      main: '#22c55e', // success
    },
    warning: {
      main: '#f59e0b', // warning
    },
    info: {
      main: '#0ea5e9', // sky-500
    },
  },
  typography: {
    fontFamily: "'Inter', system-ui, -apple-system, sans-serif",
    h1: { fontSize: '1.5rem', fontWeight: 600 },
    h2: { fontSize: '1.25rem', fontWeight: 600 },
    h3: { fontSize: '1.125rem', fontWeight: 600 },
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        // Safari (WebKit) does not redraw an outlined field's border when the label's
        // notch opens through MUI's delayed max-width transition: the floated label sits
        // on an unbroken border until a scroll repaints it. Opening and closing the notch
        // without the transition is drawn at once; the label itself still animates.
        notchedOutline: { '& > legend': { transition: 'none' } },
      },
    },
  },
});

export default theme;
